import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate';//保存vuex数据刷新不消失插件 文档：https://www.npmjs.com/package/vuex-persistedstate

import user from './user/index';
import left from './left/index';
import settings from './settings/index'
import tagsView from './tagsView/index'
import getters from './getters'
Vue.use(Vuex)

export default new Vuex.Store({
  modules:{
    user:user,
    left:left,
    settings:settings,
    tagsView
  },
  getters,
  strict: true,//严格模式
  plugins: [createPersistedState()]
})
